module.exports = __webpack_public_path__ + "static/media/808AIswitch.aeef640c.mp3";